export const heroes = [
  {
    id: 'v1001',
    title: '星际迷航者',
    subtitle: '深空探索 · 年度科幻巨制',
    category: '电影',
    meta: '2026 · 美国 · 科幻',
    image: 'https://readdy.ai/api/search-image?query=epic%20cinematic%20wide%20banner%20of%20a%20vast%20deep%20space%20scene%20with%20a%20lone%20spaceship%20silhouette%20before%20a%20giant%20glowing%20amber%20planet%2C%20dramatic%20orange%20and%20deep%20charcoal%20tones%2C%20volumetric%20lighting%2C%20starfield%20depth%2C%20high%20detail%2C%20majestic%20atmospheric%20composition%2C%20professional%20color%20grading%2C%20no%20text&width=1600&height=720&seq=tx-hero-01&orientation=landscape',
  },
  {
    id: 'v2001',
    title: '长夜将明',
    subtitle: '罪案追凶 · 悬疑口碑之作',
    category: '电视剧',
    meta: '2026 · 中国大陆 · 犯罪',
    image: 'https://readdy.ai/api/search-image?query=dark%20cinematic%20wide%20banner%20of%20a%20rainy%20night%20city%20alley%20with%20warm%20amber%20street%20lamps%20and%20long%20shadows%2C%20dramatic%20orange%20and%20deep%20charcoal%20tones%2C%20volumetric%20lighting%2C%20moody%20atmospheric%20depth%2C%20high%20detail%2C%20tense%20film%20noir%20composition%2C%20professional%20color%20grading%2C%20no%20text&width=1600&height=720&seq=tx-hero-02&orientation=landscape',
  },
  {
    id: 'v3001',
    title: '奇妙探险家',
    subtitle: '户外挑战 · 周末爆笑综艺',
    category: '综艺',
    meta: '2026 · 中国大陆 · 真人秀',
    image: 'https://readdy.ai/api/search-image?query=vibrant%20cinematic%20wide%20banner%20of%20a%20wild%20green%20mountain%20summit%20at%20golden%20hour%20with%20hikers%20in%20silhouette%2C%20warm%20orange%20and%20deep%20charcoal%20tones%2C%20dramatic%20sunlit%20volumetric%20lighting%2C%20expansive%20atmospheric%20depth%2C%20high%20detail%2C%20energetic%20adventurous%20composition%2C%20no%20text&width=1600&height=720&seq=tx-hero-03&orientation=landscape',
  },
  {
    id: 'v1003',
    title: '无声告白',
    subtitle: '层层反转 · 高分悬疑佳作',
    category: '电影',
    meta: '2024 · 韩国 · 悬疑',
    image: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20banner%20of%20an%20old%20mansion%20corridor%20with%20a%20single%20glowing%20amber%20window%20and%20drifting%20fog%2C%20dramatic%20orange%20and%20deep%20charcoal%20tones%2C%20mysterious%20volumetric%20lighting%2C%20atmospheric%20depth%2C%20high%20detail%2C%20elegant%20suspenseful%20composition%2C%20professional%20color%20grading%2C%20no%20text&width=1600&height=720&seq=tx-hero-04&orientation=landscape',
  },
  {
    id: 'v4001',
    title: '一分钟心动',
    subtitle: '城市片段 · 轻治愈短视频',
    category: '短视频',
    meta: '2026 · 中国大陆 · 生活',
    image: 'https://readdy.ai/api/search-image?query=cozy%20cinematic%20wide%20banner%20of%20a%20rainy%20city%20cafe%20window%20at%20night%20with%20warm%20amber%20fairy%20lights%20reflection%2C%20soft%20orange%20and%20deep%20charcoal%20tones%2C%20warm%20volumetric%20lighting%2C%20intimate%20atmospheric%20depth%2C%20high%20detail%2C%20tender%20elegant%20composition%2C%20no%20text&width=1600&height=720&seq=tx-hero-05&orientation=landscape',
  },
];